import { Component } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";

@Component({
    templateUrl: "./modal-success.component.html",
    styleUrls: ["./modal-success.component.scss"]
})
export class ModalSuccessComponent {
    public mensaje = "";

    constructor(private activeModal: NgbActiveModal) { }

    public cerrar(mensaje: string): void {
        this.activeModal.close(mensaje);
    }
}
